/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { BooleanSearch } from './BooleanSearch';
import {
    BooleanSearchFromJSON,
    BooleanSearchFromJSONTyped,
    BooleanSearchToJSON,
} from './BooleanSearch';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface EvaluationSearch
 */
export interface EvaluationSearch {
    /**
     * 
     * @type {TextSearch}
     * @memberof EvaluationSearch
     */
    annee?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof EvaluationSearch
     */
    codeClasse?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof EvaluationSearch
     */
    libelleClasse?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof EvaluationSearch
     */
    codeMatiere?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof EvaluationSearch
     */
    formateur?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof EvaluationSearch
     */
    type?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof EvaluationSearch
     */
    libelle?: TextSearch;
    /**
     * 
     * @type {BooleanSearch}
     * @memberof EvaluationSearch
     */
    valide?: BooleanSearch;
    /**
     * 
     * @type {Array<string>}
     * @memberof EvaluationSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof EvaluationSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof EvaluationSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof EvaluationSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof EvaluationSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof EvaluationSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the EvaluationSearch interface.
 */
export function instanceOfEvaluationSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function EvaluationSearchFromJSON(json: any): EvaluationSearch {
    return EvaluationSearchFromJSONTyped(json, false);
}

export function EvaluationSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): EvaluationSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'annee': !exists(json, 'annee') ? undefined : TextSearchFromJSON(json['annee']),
        'codeClasse': !exists(json, 'codeClasse') ? undefined : TextSearchFromJSON(json['codeClasse']),
        'libelleClasse': !exists(json, 'libelleClasse') ? undefined : TextSearchFromJSON(json['libelleClasse']),
        'codeMatiere': !exists(json, 'codeMatiere') ? undefined : TextSearchFromJSON(json['codeMatiere']),
        'formateur': !exists(json, 'formateur') ? undefined : TextSearchFromJSON(json['formateur']),
        'type': !exists(json, 'type') ? undefined : TextSearchFromJSON(json['type']),
        'libelle': !exists(json, 'libelle') ? undefined : TextSearchFromJSON(json['libelle']),
        'valide': !exists(json, 'valide') ? undefined : BooleanSearchFromJSON(json['valide']),
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function EvaluationSearchToJSON(value?: EvaluationSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'annee': TextSearchToJSON(value.annee),
        'codeClasse': TextSearchToJSON(value.codeClasse),
        'libelleClasse': TextSearchToJSON(value.libelleClasse),
        'codeMatiere': TextSearchToJSON(value.codeMatiere),
        'formateur': TextSearchToJSON(value.formateur),
        'type': TextSearchToJSON(value.type),
        'libelle': TextSearchToJSON(value.libelle),
        'valide': BooleanSearchToJSON(value.valide),
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

